import Button from "../Button/Button"
import { Plus } from "lucide-react"
import './containerlista.css'
export default function ContainerLista({pagina,itensLista,children,cadastramento,carregando}){
    if(carregando){
        return(
            <div className='container'>
                <div style={{width: "100%"}}>
                    <h2>{pagina}</h2>
                    <p>Carregando {pagina}...</p>
                </div>
            </div>
        )
    }
    if(itensLista.length === 0){
        return(
        <div className='container'>
            <div style={{ width: "100%" }}>
                <h2>{pagina}</h2>
            </div>
            <div style={{ marginBottom: '15px' }}>
                <Button icon={Plus} onClick={cadastramento}>
                    Cadastrar novo
                </Button>
            </div>
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <p>Nenhum registro encontrado em {pagina}.</p>
                <p style={{ fontSize: '0.8rem', opacity: 0.7 }}>
                    Clique no botão acima para adicionar o primeiro.
                </p>
            </div>
        </div>)
    }
    return(
        <div className='container'>
            <div style={{width: "100%"}}>
                <h2>{pagina}</h2>
            </div>
            <div style={{marginBottom:'15px'}}>
                <Button
                    icon={Plus}
                    onClick={cadastramento}
                >
                    Cadastrar novo
                </Button>
            </div>
            {children}
        </div>
    )
}